export default __webpack_public_path__ + "static/media/sd-event1.529581df.png";